<script setup>
import { useI18n } from 'vue-i18n';
import { onMounted, computed } from 'vue';

const { t } = useI18n();

const props = defineProps({
  selectedTemplate: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const selectedTemplate = props.selectedTemplate;

const getComponent = (type) => {
  return (
    (Array.isArray(selectedTemplate?.components) &&
      selectedTemplate.components.find((comp) => comp.type === type)) ||
    null
  );
};

// ✅ NOVO: Computed para obter a URL da imagem do header
const headerImageUrl = computed(() => {
  const header = getComponent('HEADER');
  if (!header || header.format !== 'IMAGE') return null;
  
  // A imagem pode estar em diferentes lugares dependendo do template
  return header.example?.header_handle?.[0] || null;
});

// ✅ NOVO: Computed para verificar se tem documento
const headerDocumentUrl = computed(() => {
  const header = getComponent('HEADER');
  if (!header || header.format !== 'DOCUMENT') return null;
  
  return header.example?.header_handle?.[0] || null;
});

// ✅ NOVO: Computed para verificar se tem vídeo
const headerVideoUrl = computed(() => {
  const header = getComponent('HEADER');
  if (!header || header.format !== 'VIDEO') return null;
  
  return header.example?.header_handle?.[0] || null;
});

// ✅ NOVO: Computed para texto do header
const headerText = computed(() => {
  const header = getComponent('HEADER');
  if (!header || header.format !== 'TEXT') return null;
  
  return header.text || null;
});

onMounted(() => {
  //console.log('TemplatePreview - Componente montado', props.selectedTemplate);
});

const formatBodyText = (text) => {
  if (!text) return '';
  return text
    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
    .replace(/{{(\w+)}}/g, '{{$1}}')
    .replace(/\n/g, '<br>');
};
</script>
<template>
  <div v-if="selectedTemplate">
    <div class="panel-content">
      <div class="phone-preview">
        <div class="phone-frame">
          <div class="screen-notch"></div>
          <div class="chat-container">
            <div class="status-bar">
              <div class="status-left">
                <div class="signal-bars">
                  <span class="bar active"></span>
                  <span class="bar active"></span>
                  <span class="bar"></span>
                  <span class="bar"></span>
                </div>
                <span class="carrier">Claro</span>
              </div>
              <div class="status-center">
                <span class="time">21:00</span>
              </div>
              <div class="status-right">
                <div class="status-icons">
                  <div class="wifi-icon">
                    <div class="wifi-bar"></div>
                    <div class="wifi-bar"></div>
                    <div class="wifi-bar"></div>
                  </div>
                  <div class="battery-icon">
                    <div class="battery-body">
                      <div class="battery-level"></div>
                    </div>
                    <div class="battery-tip"></div>
                  </div>
                  <span class="battery-percent">85%</span>
                </div>
              </div>
            </div>
            <div class="chat-header">
              <div class="header-left">
                <div class="back-arrow">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                  </svg>
                </div>
                <div class="contact-info">
                  <div class="contact-avatar">
                    <div class="avatar-circle">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                      </svg>
                    </div>
                  </div>
                  <div class="contact-details">
                    <span class="contact-name">CortexWoot</span>
                    <span class="contact-status">online</span>
                  </div>
                </div>
              </div>
              <div class="header-actions">
                <div class="action-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <div class="action-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="1"/>
                    <circle cx="19" cy="12" r="1"/>
                    <circle cx="5" cy="12" r="1"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="chat-content">
              <div class="message-content">
                <!-- ✅ Header com TEXTO -->
                <div v-if="headerText" class="message-header-text">
                  <p class="header-text" v-html="formatBodyText(headerText)"></p>
                </div>

                <!-- ✅ Header com IMAGEM -->
                <div v-if="headerImageUrl" class="message-header-media">
                  <img 
                    :src="headerImageUrl" 
                    alt="Template header image" 
                    class="header-image"
                    @error="$event.target.style.display='none'"
                  />
                </div>

                <!-- ✅ Header com VÍDEO -->
                <div v-if="headerVideoUrl" class="message-header-media">
                  <video 
                    :src="headerVideoUrl" 
                    class="header-video"
                    controls
                    @error="$event.target.style.display='none'"
                  >
                    Seu navegador não suporta vídeo.
                  </video>
                </div>

                <!-- ✅ Header com DOCUMENTO -->
                <div v-if="headerDocumentUrl" class="message-header-document">
                  <div class="document-preview">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <path d="M14 2v6h6"/>
                      <path d="M16 13H8"/>
                      <path d="M16 17H8"/>
                      <path d="M10 9H8"/>
                    </svg>
                    <span class="document-name">Documento</span>
                  </div>
                </div>

                <!-- Body text -->
                <p
                  class="message-text"
                  v-html="formatBodyText(getComponent('BODY')?.text)"
                ></p>

                <!-- Footer -->
                <p class="message-footer" v-if="getComponent('FOOTER')?.text">
                  {{ getComponent('FOOTER')?.text }}
                </p>

                <!-- Message time -->
                <div class="message-time">
                  <span>21:02</span>
                  <div class="message-status">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 6L9 17l-5-5"/>
                      <path d="M16 6L9 13"/>
                    </svg>
                  </div>
                </div>
              </div>
              
              <!-- Buttons -->
              <div class="buttons" v-if="getComponent('BUTTONS')">
                <button
                  v-for="(button, index) in getComponent('BUTTONS').buttons"
                  :key="index"
                  class="whatsapp-button"
                >
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.phone-frame {
  @apply rounded-3xl w-full max-w-80 h-[580px] relative overflow-hidden border border-woot-400;
  border: 2px solid theme('colors.n.slate.6');
  background: theme('colors.n.slate.2');
  box-shadow: 
    0 0 0 1px theme('colors.n.alpha.1'),
    0 20px 60px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 theme('colors.n.alpha.white');
}

.screen-notch {
  @apply absolute top-2 left-1/2 transform -translate-x-1/2 w-32 h-6 z-10;
  background: theme('colors.n.slate.12');
  border-radius: 0 0 16px 16px;
}

.chat-container {
  @apply h-full flex flex-col overflow-hidden relative;
  background: theme('colors.n.slate.1');
}

.status-bar {
  @apply flex justify-between items-center px-5 py-3 mt-7 text-sm font-semibold;
  background: transparent;
  color: theme('colors.n.slate.12');
}

.status-left {
  @apply flex items-center gap-2;
}

.signal-bars {
  @apply flex gap-0.5 items-end;
}

.signal-bars .bar {
  @apply w-0.5 rounded-sm;
  background: theme('colors.n.slate.6');
}

.signal-bars .bar:nth-child(1) { @apply h-1; }
.signal-bars .bar:nth-child(2) { @apply h-1.5; }
.signal-bars .bar:nth-child(3) { @apply h-2; }
.signal-bars .bar:nth-child(4) { @apply h-2.5; }
.signal-bars .bar.active { 
  background: theme('colors.n.slate.12'); 
}

.carrier {
  @apply text-xs font-medium;
  color: theme('colors.n.slate.11');
}

.status-center .time {
  @apply text-sm font-semibold;
  color: theme('colors.n.slate.12');
}

.status-right {
  @apply flex items-center gap-1;
}

.status-icons {
  @apply flex items-center gap-1.5;
}

.wifi-icon {
  @apply flex gap-px items-end;
}

.wifi-bar {
  @apply w-0.5 rounded-sm;
  background: theme('colors.n.slate.12');
}

.wifi-bar:nth-child(1) { @apply h-0.5; }
.wifi-bar:nth-child(2) { @apply h-1; }
.wifi-bar:nth-child(3) { @apply h-1.5; }

.battery-icon {
  @apply flex items-center;
}

.battery-body {
  @apply w-5 h-2.5 rounded-sm relative;
  border: 1px solid theme('colors.n.slate.12');
  background: transparent;
}

.battery-level {
  @apply w-[85%] h-full rounded-sm;
  background: theme('colors.n.teal.9');
}

.battery-tip {
  @apply w-0.5 h-1.5 ml-px;
  background: theme('colors.n.slate.12');
  border-radius: 0 1px 1px 0;
}

.battery-percent {
  @apply text-xs font-medium ml-1;
  color: theme('colors.n.slate.11');
}

.chat-header {
  @apply px-4 py-3 flex items-center justify-between;
  background: theme('colors.n.slate.2');
  color: theme('colors.n.slate.12');
  border-bottom: 1px solid theme('colors.n.slate.6');
}

.header-left {
  @apply flex items-center gap-3;
}

.back-arrow {
  @apply cursor-pointer p-1 rounded-full transition-colors;
  color: theme('colors.n.teal.9');
}

.back-arrow:hover {
  background: theme('colors.n.teal.3');
}

.contact-info {
  @apply flex items-center gap-3;
}

.contact-avatar .avatar-circle {
  @apply w-9 h-9 rounded-full flex items-center justify-center;
  background: linear-gradient(135deg, theme('colors.n.teal.9'), theme('colors.n.teal.8'));
  color: white;
}

.contact-details {
  @apply flex flex-col gap-0.5;
}

.contact-name {
  @apply font-semibold text-xs;
  color: theme('colors.n.slate.12');
}

.contact-status {
  @apply text-xs font-medium;
  color: theme('colors.n.teal.9');
}

.header-actions {
  @apply flex gap-4 mb-2;
}

.action-icon {
  @apply cursor-pointer p-1 ml-2 rounded-full transition-colors;
  color: theme('colors.n.teal.9');
}

.action-icon:hover {
  background: theme('colors.n.teal.3');
}

.chat-content {
  @apply flex-1 px-2 py-2 overflow-y-auto relative;
  background: linear-gradient(to bottom, theme('colors.n.slate.1'), theme('colors.n.slate.2'));
}

.chat-content::before {
  @apply absolute inset-0 pointer-events-none;
  content: '';
  opacity: 0.3;
  background-image: radial-gradient(circle at 1px 1px, theme('colors.n.slate.6') 1px, transparent 0);
  background-size: 20px 20px;
}

@media (prefers-color-scheme: dark) {
  .chat-content::before {
    background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.03) 1px, transparent 0);
    opacity: 1;
  }
}

.message-content {
  @apply rounded-2xl px-4 py-3 pb-2 max-w-[100%] relative overflow-hidden;
  background: theme('colors.n.teal.9');
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

@media (prefers-color-scheme: light) {
  .message-content {
    background: theme('colors.n.teal.8');
    color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
}

/* ✅ ESTILOS para header DENTRO de message-content */

.message-header-text {
  @apply mb-2 pb-2 border-b;
  border-color: rgba(255, 255, 255, 0.2);
}

.header-text {
  @apply m-0 text-base font-semibold leading-relaxed;
  color: white;
}

.message-header-media {
  @apply -mx-4 -mt-3 mb-3 overflow-hidden;
  border-radius: 12px 12px 0 0;
}

.header-image {
  @apply w-full h-auto max-h-64 object-cover;
  display: block;
}

.header-video {
  @apply w-full h-auto max-h-64;
  display: block;
  background: black;
}

.message-header-document {
  @apply mb-3 p-3 rounded-lg -mx-4 -mt-3;
  background: rgba(255, 255, 255, 0.1);
}

.document-preview {
  @apply flex items-center gap-3;
  color: white;
}

.document-name {
  @apply text-sm font-medium;
}

.message-text {
  @apply m-0 mb-1 text-sm leading-relaxed font-normal break-words;
  color: inherit;
}

.message-footer {
  @apply my-2 mb-1 text-xs italic;
  color: rgba(255, 255, 255, 0.8);
}

.message-time {
  @apply flex items-center justify-end gap-1 mt-1;
}

.message-time span {
  @apply text-xs font-normal;
  color: rgba(255, 255, 255, 0.7);
}

.message-status {
  @apply flex items-center;
  color: theme('colors.n.blue.4');
}

.buttons {
  @apply flex flex-col gap-2 mt-3 relative z-[1];
}

.whatsapp-button {
  @apply rounded-2xl px-5 py-3 text-sm font-medium cursor-pointer text-center transition-all duration-200;
  background: theme('colors.n.slate.3');
  color: theme('colors.n.teal.11');
  border: 1px solid theme('colors.n.slate.6');
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.whatsapp-button:hover {
  background: theme('colors.n.slate.4');
  border-color: theme('colors.n.teal.7');
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (prefers-color-scheme: dark) {
  .whatsapp-button {
    background: theme('colors.n.slate.3');
    color: theme('colors.n.teal.9');
    border-color: theme('colors.n.slate.6');
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .whatsapp-button:hover {
    background: theme('colors.n.slate.4');
    border-color: theme('colors.n.teal.7');
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  }
}

/* Responsividade */
@media (max-width: 1024px) {
  .phone-frame {
    @apply max-w-[280px] h-[520px];
  }

  .message-text {
    @apply text-xs;
  }

  .whatsapp-button {
    @apply text-xs px-4 py-2;
  }

  .header-image,
  .header-video {
    @apply max-h-48;
  }
}

@media (max-width: 768px) {
  .phone-frame {
    @apply max-w-[260px] h-[480px];
  }

  .status-bar {
    @apply px-4 py-2.5 pt-2 text-xs;
  }

  .contact-name {
    @apply text-sm;
  }

  .message-text {
    @apply text-xs;
  }

  .whatsapp-button {
    @apply text-xs px-4 py-2.5;
  }

  .header-image,
  .header-video {
    @apply max-h-40;
  }

  .message-header-document {
    @apply p-2;
  }

  .document-preview svg {
    @apply w-8 h-8;
  }

  .document-name {
    @apply text-xs;
  }
}

/* Animação de loading para imagens */
.header-image {
  @apply transition-opacity duration-300;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>